import { FC, useState } from 'react';
import { Button } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';

import { JobSearchFilterModal } from '../Modal';

export const JobFilterModalButton: FC = () => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Button
        aria-label="Filter Jobs"
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        sx={{
          borderColor: 'grey.400',
          color: 'text.secondary',
          transition: 'all 0s ease',
          minWidth: '40px',
          width: { xs: '100%', sm: '40px' },
          height: '40px',
          my: 1,

          '&:hover': {
            borderColor: 'secondary.dark',
            backgroundColor: 'background.paper',
          },
        }}
      >
          {open ? <CloseIcon /> : <FilterAltIcon />}
      </Button>
      <JobSearchFilterModal open={open} onClose={handleClick} />
    </>
  );
};
